// Note that the collection is extended from an array.
// However be careful when iterating through the properties as we may have added additional properties which will also be iterated over.

import Collection from "../../../lib/collection";

export class PaneOptionCollection extends Collection {

    constructor(...items) {
        super(...items);
    }

    withIdentifier(identifier) {
        return this.findByProp('identifier', identifier) || null;
    }

    allWithIdentifiers(identifiers) {
        if (this.isEmpty()) { return [] };
        return this.filter( item => identifiers.includes(item.identifier) );
    }

}
